import styled from 'styled-components'
import { useIntl, FormattedMessage } from 'react-intl'

import Card from '@10xLabs/react-web/components/Card'
import { FormattedDate } from '@10xLabs/react-web/components/FormattedDate'
import { FormattedRoute } from '@10xLabs/react-web/components/FormattedRoute'
import { FormattedTimeByDate } from '@10xLabs/react-web/components/FormattedTimeByDate'
import Heading from 'components/v2/Heading'
import { ContentHeader } from 'components/v2/Content'
import { StopsList } from './StopsList'
import { ReactElement } from 'react'
import { GTTripBookings } from 'gql/types.generated'

const Flex = styled.div<TSFixMe>`
  display: flex;
  align-items: center;
`

const HeaderWrapper = styled.div<TSFixMe>`
  display: flex;
  flex-wrap: wrap;
  gap: 3px 30px;
`

interface ITripPassengersContentProps {
  tripBookings: GTTripBookings
}

export const TripPassengersContent = ({ tripBookings }: ITripPassengersContentProps): ReactElement => {
  const intl = useIntl()

  return (
    <>
      <ContentHeader>
        <Heading.H4>
          <HeaderWrapper>
            <div>
              <FormattedMessage
                id="trips.passengers.routeServiceCode.title"
                defaultMessage="Trip {routeServiceCode}"
                values={{
                  routeServiceCode: tripBookings.routeServiceCode
                }}
              />
            </div>
            <div>
              <FormattedRoute origin={tripBookings.origin} destination={tripBookings.destination} />
            </div>
            <Flex>
              <FormattedDate
                intl={intl}
                value={tripBookings.departureAt}
                month="2-digit"
                day="2-digit"
                year="numeric"
              />
              &nbsp;
              <FormattedTimeByDate
                intl={intl}
                date={tripBookings.departureAt}
                timeZone={tripBookings.origin.timezone || undefined}
              />
            </Flex>
          </HeaderWrapper>
        </Heading.H4>
      </ContentHeader>
      <Card.Container>
        <Card.Content noHeader noFooter>
          <StopsList tripBookings={tripBookings} />
        </Card.Content>
      </Card.Container>
    </>
  )
}
